// Display formatters used across the UI.
export const money = (n: number): string =>
  (n < 0 ? "-$" : "$") + Math.round(Math.abs(n)).toLocaleString("en-US");

export const money0 = (n: number): string =>
  "$" + Math.round(n).toLocaleString("en-US");

export const pct = (n: number, d = 1): string => (n * 100).toFixed(d) + "%";

export const x2 = (n: number): string => n.toFixed(2) + "×";

/** Compact money for chart axes / tight KPIs: $1.2M, $850k, $12k. */
export const moneyShort = (n: number): string => {
  const s = n < 0 ? "-" : "";
  const a = Math.abs(n);
  if (a >= 1e6) return `${s}$${(a / 1e6).toFixed(a >= 1e7 ? 1 : 2)}M`;
  if (a >= 1e3) return `${s}$${Math.round(a / 1e3)}k`;
  return `${s}$${Math.round(a)}`;
};
